import React from 'react';

function Error() {
  return (
    <div className="col-md-8 col-lg-6 offset-md-2 offset-lg-3 mb-14">
      <h1 className="heading6 mb-7">{_THULEDATA._Returns.LoginToCreateReturn}</h1>
      {_THULEDATA._Returns.LoginUrl && _THULEDATA._Returns.Login && (
        <a href={_THULEDATA._Returns.LoginUrl} className="btn thule-btn-default login-btn">
          {_THULEDATA._Returns.Login}
        </a>
      )}
    </div>
  );
}

export default Error;
